import {UtilsAxiosPost} from "@/utils/utils_axios";

export const visitSubmit = (data) => {
    return UtilsAxiosPost({
        url: "/visit/submit",
        data
    });
}
